import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/posts";

export default function HeroSection() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20dramatic%20warm%20crimson%20and%20gold%20bokeh%20lights%2C%20dark%20moody%20film%20noir%20gradient%2C%20soft%20glowing%20particles%2C%20luxurious%20editorial%20entertainment%20mood%2C%20no%20people%2C%20no%20readable%20text%2C%20high%20detail&width=1600&height=900&seq=gossip-hero-01&orientation=landscape"
          alt="吃瓜看料聚集地背景图"
          title="吃瓜看料聚集地 - 全网热门吃瓜看料平台"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-16 md:py-24 lg:py-28">
        <div className="mx-auto max-w-3xl text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs md:text-sm font-medium text-accent-200 backdrop-blur-sm">
            <i className="ri-flashlight-fill text-accent-300" aria-hidden="true"></i>
            每日更新 · 全网热点第一时间送达
          </span>
          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-white">
            全网热门
            <span className="text-accent-400">吃瓜看料</span>
            聚集地
          </h1>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-white/80">
            娱乐八卦、社会热点、行业秘闻一网打尽。无论你想看明星动态还是职场爆料，
            这里都是你的吃瓜看料基地，海量内容等你来挖。
          </p>

          <form
            onSubmit={handleSearch}
            className="mx-auto mt-8 flex w-full max-w-xl flex-col sm:flex-row items-stretch gap-2 rounded-full bg-white/95 p-2 backdrop-blur-sm"
          >
            <div className="flex flex-1 items-center gap-2 px-3">
              <i className="ri-search-line text-lg text-foreground-500" aria-hidden="true"></i>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                type="search"
                placeholder="想吃什么瓜？试试搜「顶流」「大厂」"
                className="w-full bg-transparent py-2 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
            </div>
            <button
              type="submit"
              className="rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
            >
              开始吃瓜
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            {categories.map((item) => (
              <Link
                key={item.slug}
                to={`/category/${item.slug}`}
                className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs md:text-sm text-white whitespace-nowrap backdrop-blur-sm transition-colors hover:bg-white/20"
              >
                <i className={item.icon} aria-hidden="true"></i>
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}